import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';

const cache = new InMemoryCache();

const link = new HttpLink({
    uri: process.env.REACT_APP_API_URL,
});

export const apolloClient = new ApolloClient({
    cache,
    link,
});
